import { getElementsByClassName } from './utils';

const parseFormula = (
  formula: string,
  table: Record<number, Record<string, number>>,
  spreadsheets?: Record<string, Record<number, Record<string, number>>>,
): number | string => {
  try {
    const stack: (number | string)[] = [];
    for (const action of formula.split(' ')) {
      console.log(action);
      switch (action) {
        case '=':
          // Bail for the definition
          break;

        case '+':
          (() => {
            const first = stack.pop();
            const second = stack.pop();

            if (typeof first !== 'number' || typeof second !== 'number') {
              throw new Error('Expected two numbers on the stack!');
            }

            stack.push(first + second);
          })();
          break;

        case '*':
          (() => {
            const first = stack.pop();
            const second = stack.pop();

            if (typeof first !== 'number' || typeof second !== 'number') {
              throw new Error('Expected two numbers on the stack!');
            }

            stack.push(first * second);
          })();
          break;

        case '/':
          (() => {
            const first = stack.pop();
            const second = stack.pop();

            if (typeof first !== 'number' || typeof second !== 'number') {
              throw new Error('Expected two numbers on the stack!');
            }

            stack.push(first / second);
          })();
          break;

        case '^':
          (() => {
            const first = stack.pop();

            if (typeof first !== 'number') {
              throw new Error('Expected two numbers on the stack!');
            }

            stack.push(first.toPrecision(3));
          })();
          break;

        case '$':
          stack.push(`$${stack.pop()}`);
          break;

        default:
          if (action[0] === '!') {
            if (!spreadsheets) {
              throw new Error('Spreadsheets missing?');
            }

            const [sheetName, cell] = action.replace('!', '').split(':');
            const sheet = spreadsheets[sheetName];

            if (!sheet) {
              throw new Error(
                `Unable to find specified spreadsheet: ${sheetName}`,
              );
            }

            const [row, column] = [cell.slice(0, 1), cell.slice(1)];
            stack.push(sheet[parseInt(column)][row]);
          } else {
            const [row, column] = [action.slice(0, 1), action.slice(1)];
            console.log(`ACCESSING ${row}${column}`);
            stack.push(table[parseInt(column)][row]);
          }
      }
    }

    if (typeof stack[0] !== 'number' && stack[0][0] !== '$') {
      throw new Error(
        `Stack not a number! ${stack[0]} (typeof ${typeof stack[0]})`,
      );
    }

    return stack[0];
  } catch (error) {
    console.error(error, table);
    return 'ERR';
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const tableWrappers = getElementsByClassName<HTMLDivElement>('spreadsheet');

  let spreadsheets = {};

  for (const wrapper of tableWrappers) {
    const name = wrapper.dataset.name;

    if (!name) {
      return [];
    }

    const table = wrapper.querySelector('table');

    if (!table) {
      return [];
    }

    const tableData: Record<number, Record<string, number>> = {};
    for (let rowIndex = 0; rowIndex < table.rows.length; rowIndex++) {
      const row = table.rows[rowIndex];
      tableData[rowIndex] = {};

      let letter = 'A';
      for (let columnIndex = 0; columnIndex < row.cells.length; columnIndex++) {
        letter = String.fromCharCode(65 + columnIndex);

        const cell = row.cells[columnIndex];

        if (cell.innerText[0] === '=') {
          const value = parseFormula(cell.innerText, tableData, spreadsheets);
          cell.innerText = value.toString();

          if (typeof value === 'number') {
            tableData[rowIndex][letter] = value;
          } else {
            tableData[rowIndex][letter] = parseFloat(value.replaceAll('$', ''));
          }

          continue;
        }

        tableData[rowIndex][letter] = parseFloat(
          cell.innerText.replaceAll('$', ''),
        );
      }
    }

    spreadsheets = {
      ...spreadsheets,
      [name]: tableData,
    };
  }

  console.log('Sheets', spreadsheets);
});
